import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroSalesInvoiceForm.XeroSalesInvoiceFieldsSection', {
    customerFieldTitle: 'Customer',
    customerFieldPlaceholder: 'Choose customer',
    dateFieldTitle: 'Date',
    dateFieldPlaceholder: 'Enter date',
    dueDateFieldTitle: 'Due date',
    dueDateFieldPlaceholder: 'Enter date',
    referenceFieldTitle: 'Reference',
    referenceFieldPlaceholder: 'Enter reference',
    invoiceNumberFieldTitle: 'Invoice #',
    invoiceNumberFieldPlaceholder: 'Enter invoice number',
    themeFieldTitle: 'Theme',
    themeFieldPlaceholder: 'Choose theme',
    addCustomerButton: '+ New Customer',
    multipleCustomersWarning: 'Multiple customers detected. Check suggested customers.',
    earlyDueDateWarning: 'Due date is earlier than the Date.',
});
